// extracted by mini-css-extract-plugin
export default {"addRowBtn":"MaterialWarehousing_addRowBtn__QGraX","content":"MaterialWarehousing_content__RIYQS"};